// extracted by mini-css-extract-plugin
export default {"main":"Main_main__yowlL","container":"Main_container__gpNjg"};